module.exports.VectorTile = require('./lib/vectortile.js');
module.exports.VectorTileFeature = require('./lib/vectortilefeature.js');
module.exports.VectorTileLayer = require('./lib/vectortilelayer.js');



/*****************
 ** WEBPACK FOOTER
 ** ./~/vector-tile/index.js
 ** module id = 92
 ** module chunks = 0
 **/